import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Layout from '../../components/global/layout';
import './style.scss';
import ApiClient from '../../methods/api/apiClient';
import methodModel from '../../methods/methods';
import { PiUsersThreeLight } from "react-icons/pi";
import { PiCertificateLight } from "react-icons/pi";
import { loadavg } from 'os';
import loader from '../../methods/loader';
import { GrTransaction } from "react-icons/gr";
import { useNavigate } from 'react-router-dom';




const Dashboard = () => {
  const user = useSelector((state: any) => state.user);
  const [userData, setUserData] = useState({ totalUser: "", totalParents: "", totalLeagues: "", totalCoaches: "", totalAthlete: "" })
  const [certificateData, setcertificateData] = useState({ totalCertificate: "", acceptedCertificate: "", paendingCertificate: "", rejectedCertificate: "" })
  const [total, setTotal] = useState(0)
  const history = useNavigate()

  const getUserData = () => {
    loader(true)
    ApiClient.get(`UserDashboard`).then((res) => {
      if (res.success) {
        loader(false)
        setUserData(res.data)
      }
    })
  }

  const getTotalTranasactions = () => {
    loader(true)
    ApiClient.get(`getAllTransactions?isDeleted=false`).then((res) => {
      if (res.success) {
        loader(false)
        setTotal(res?.data?.length)
      }
    })
  }

  const getDsahboardCertificate = () => {
    loader(true)
    ApiClient.get(`getDsahboardCertificate`).then((res) => {
      if (res.success) {
        loader(false)
        setcertificateData(res?.data)
      }
    })
  }

  useEffect(() => {
    getTotalTranasactions()
    getUserData()
    getDsahboardCertificate()
  }, [])

  const Redirectopage = (data: any) => {
    console.log(data, "data")
    if (data === "Total Users") {
      history("/users")
    } else if (data === "Total Parents") {
      history("/users?role=parents")
    }
    else if (data === "Total Leagues") {
      history("/users?role=leagues")
    }
    else if (data === "Total Coaches") {
      history("/users?role=coaches")
    } else if (data === "Total Athletes") {
      history("/users?role=athlete")
    } else if (data === "Total Certificate") {
      history("/certificate-requests")
    } else if (data === "Accepted Certificate") {
      history("/certificate-requests?filter=accepted")
    } else if (data === "Pending Certificate") {
      history("/certificate-requests?filter=pending")
    } else {
      history("/certificate-requests?filter=rejected")
    }

  }


  return (
    <Layout>

      <main className="space-y-6">
        <div className="flex flex-col space-y-6 md:space-y-0 md:flex-row justify-between">
          <div className="mr-6">
            <h1 className="text-[25px] font-semibold text-capitalize leading-[28px]">Hi {methodModel.capitalizeFirstLetter(user?.fullName)}</h1>
            <h2 className="text-[14px] text-[#838383]">Dashboard</h2>
          </div>

        </div>
        <section className="grid grid-cols-12 gap-6">
          {[
            { label: 'Total Users', value: userData.totalUser },
            { label: 'Total Parents', value: userData.totalParents },
            { label: 'Total Leagues', value: userData.totalLeagues },
            { label: 'Total Coaches', value: userData.totalCoaches },
            { label: 'Total Athletes', value: userData.totalAthlete },
          ].map((item: any, index) => (
            <div title={item?.label} onClick={e => Redirectopage(item?.label)} key={index} className='col-span-12 pointer sm:col-span-6 md:col-span-6 lg:col-span-4 bg-white shadow rounded-lg'>
              <div className='rounded-lg bg-card flex justify-between items-center p-3 gap-2 border-l-[3px] border-[#a42238]'>
                <div className=''>
                  <div className='flex items-center text-[15px] font-[500] leading-[16px]'>
                    {item.label}
                  </div>
                  <h1 className='mt-5 font-[600] text-[#686868] text-[24px]'>
                    {item?.value < 10 ? "0" + item?.value : item?.value || "00"}
                  </h1>
                </div>
                <div className='svg_icons w-[50px] h-[50px] rounded-[50%] bg-[#A12238] flex justify-center items-center'>
                  <PiUsersThreeLight className='text-[#fff] text-[22px]' />
                </div>
              </div>
            </div>
          ))}



          {[
            { label: 'Total Certificate', value: certificateData.totalCertificate },
            { label: 'Accepted Certificate', value: certificateData.acceptedCertificate },
            { label: 'Pending Certificate', value: certificateData.paendingCertificate },
            { label: 'Rejected Certificate', value: certificateData.rejectedCertificate }
          ].map((item: any, index) => (
            <div title={item?.label} onClick={e => Redirectopage(item?.label)} key={index} className='col-span-12 pointer sm:col-span-6 md:col-span-6 lg:col-span-4 bg-white shadow rounded-lg'>
              <div className='rounded-lg bg-card flex justify-between items-center p-3 gap-2 border-l-[3px] border-[#a42238]'>
                <div className=''>
                  <div className='flex items-center text-[15px] font-[500] leading-[16px]'>
                    {item.label}
                  </div>
                  <h1 className='mt-5 font-[600] text-[#686868] text-[24px]'>
                    {item?.value < 10 ? "0" + item?.value : item?.value || "00"}
                  </h1>
                </div>
                <div className='svg_icons w-[50px] h-[50px] rounded-[50%] bg-[#A12238] flex justify-center items-center'>
                  <PiCertificateLight className='text-[#fff] text-[22px]' />

                </div>
              </div>
            </div>
          ))}

          <div title='Total Tranasactions' onClick={e => history("/Transactions")} className='col-span-12 pointer sm:col-span-6 md:col-span-6 lg:col-span-4 bg-white shadow rounded-lg'>
            <div className='rounded-lg bg-card flex justify-between items-center p-3 gap-2 border-l-[3px] border-[#a42238]'>
              <div className=''>
                <div className='flex items-center text-[15px] font-[500] leading-[16px]'>
                  Total Tranasactions
                </div>
                <h1 className='mt-5 font-[600] text-[#686868] text-[24px]'>
                  {total < 10 ? "0" + total : total || "00"}
                </h1>
              </div>
              <div className='svg_icons w-[50px] h-[50px] rounded-[50%] bg-[#A12238] flex justify-center items-center'>
                <GrTransaction className='text-[#fff] text-[22px]' />
              </div>
            </div>
          </div>
        </section>

        {/* <section className="grid grid-cols-12 gap-6">
          <div className="col-span-12 bg-white shadow rounded-lg">
            <div className="px-6 py-5 font-semibold border-b border-gray-100">Courses</div>
            <div className="p-4 flex-grow h-[25rem]">
              <div className="flex items-center justify-center h-full px-4 py-16 text-gray-400 text-3xl font-semibold bg-gray-100 border-2 border-gray-200 border-dashed rounded-md">Chart</div>
            </div>
          </div>
        </section> */}
      </main>

    </Layout>
  );
};

export default Dashboard;